import { Routes, Route, useLocation, useParams, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import CreateOrJoinRoom from './components/join/CreateOrJoinRoom';
import CreateRoom from './components/join/CreateRoom';
import JoinRoom from './components/join/JoinRoom';
import DirectJoin from './components/join/DirectJoin';
import WaitingRoom from './components/join/WaitingRoom';
import PlayGame from './components/gameplay/PlayGame';
import WinnersPodium from './components/WinnersPodium';
import PrivacyPolicyPage from './components/PrivacyPolicy';
import ContactPage from './components/contact';
import HowToPlayPage from './components/HowToPlay';

function WaitingRoomWrapper() {
  const location = useLocation();
  const { roomId } = useParams();
  const state = location.state || {};
  
  // If the user doesn't have location state (direct navigation to URL), redirect to DirectJoin
  if (!state.playerName) {
    return <Navigate to={`/app/join/${roomId}`} replace />;
  }
  
  const { isAdmin, playerName } = state;
  return <WaitingRoom isAdmin={isAdmin} roomId={roomId || ''} playerName={playerName} />;
}

function App() {
  const location = useLocation();

  // If we're not on an /app route, redirect to the static landing page
  if (!location.pathname.startsWith('/app')) {
    window.location.href = '/';
    return null;
  }

  // Don't show the back button for privacy, contact, and how-to-play pages
  const hideBackButton = ['/app/privacy', '/app/contact', '/app/how-to-play'].includes(location.pathname) || location.pathname.startsWith('/app/winners/');

  return (
    <HelmetProvider>
      <div className="min-h-screen bg-gray-900">
        {!hideBackButton && (
          <div className="max-w-7xl mx-auto px-4 py-4">
            <button 
              onClick={() => window.location.replace('/')} 
              className="text-gray-400 hover:text-white text-sm"
            >
              ← Back to Home
            </button>
          </div>
        )}
        <Routes>
          <Route path="/app" element={<CreateOrJoinRoom />} />
          <Route path="/app/create" element={<CreateRoom />} />
          <Route path="/app/join" element={<JoinRoom />} />
          <Route path="/app/join/:roomId" element={<DirectJoin />} />
          <Route path="/app/room/:roomId" element={<WaitingRoomWrapper />} />
          <Route path="/app/play/:roomId" element={<PlayGame />} />
          <Route path="/app/winners/:roomId" element={<WinnersPodium />} />
          <Route path="/app/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/app/contact" element={<ContactPage />} />
          <Route path="/app/how-to-play" element={<HowToPlayPage />} />
        </Routes>
      </div>
    </HelmetProvider>
  );
}

export default App; 